export const visit = (vm, at) => {
at({ "en": { "breezeSegmentSetup": { "setupPrompt": "Help me set up audience segments for my business." } } });
};